import React from 'react';
import { Button as CoreButton } from 'localmed-core';

import isFullNavigation from '../../utils/fullNavigation';

export default function Button(props) {
  return <CoreButton {...props} fullNavigation={isFullNavigation(props.to)} />;
}
